export const objectToString = (obj) => {
  const list = []
  for (let i = 0; i < Object.keys(obj).length; i++) {
    const key = Object.keys(obj)[i];
    const value = obj[key];
    if (value) {
      if (typeof value === 'string' && value) {
        list.push(`${key}:${value}`);
      } else {
        list.push(key);
      }
    }
  }
  return list.join(';');
}